// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal {
  box-shadow: none !important;
}

.product-modal-container {
  width: 100% !important;
}

.product-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 2rem;
  position: relative;
  width: 100%;
}
.view-btn-parent .ant-btn-color-link.ant-btn-variant-link {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.view-on-map {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.view-btn-parent .ant-btn-color-link.ant-btn-variant-link {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.view-on-map {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.multi-slot-dates-table {
  max-height: 20vh !important;
  overflow-y: auto !important;
}
.product-image-container {
  width: 35%;
  margin-inline-start: 2%;
}

.product-image-container img {
  max-height: 470px;

  margin-top: -2%;
  display: flex;
}

.main-product-img .ant-image {
  width: 100%;
}

.main-product-img .ant-image .ant-image-img {
  width: 100%;
  height: 500px;
  flex-shrink: 0;
  border-radius: 10px;
  background: lightgray 50% / cover no-repeat;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.google-map-container {
  background: lightgray 50% / cover no-repeat;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.thumbnail-img.active-thumbnail {
  border: 1px solid #d2042d; /* or your theme color */
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}
.select-date-text {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-inline-start: 1rem;
}

.calendar-message-paragraph {
  font-family: Roboto;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: #f5f5f5;
}
.menu-items-product-modal {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.menu-items-campaign-names {
  color: "var(--Colors-Text-500, #0A0F0D)" !important;
  font-size: 20px !important;
  font-weight: 200px !important;
  font-style: normal !important;
}
.add-to-campaign-footer-second {
  display: flex !important;
  align-items: center !important;
  gap: 2rem !important;
}
.calendar-description {
  font-family: Roboto;
  text-wrap: inherit;
  color: #373737;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.minimum-dates {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.ant-picker-footer {
  display: none;
}

.custom-datepicker .ant-picker-panel-layout {
  flex-shrink: 0;
  position: absolute !important;
  border-radius: 12.133px;
  border: 1.213px solid #ddd;
  background: #fff;
  margin-inline-start: 1rem;
}

.hidden-date-picker .ant-picker-input {
  display: none !important;
}

.hidden-date-picker.ant-picker-outlined {
  border-style: none !important;
}

.bookamark-icon {
  position: absolute;
}

.bookmark-icon:hover {
  transform: scale(1.2);
}

.image-thumbnail-row {
  margin-top: 8%;
}

.thumbnail-img {
  cursor: pointer;
  width: 72px !important;
  height: 72px !important;
  border-radius: 10px;
  display: flex !important;
  margin-right: 0.8rem;
  margin-top: 10px;
  position: relative;
  transition:
    border 0.2s ease-in-out,
    transform 0.2s ease-in-out;
  border: 2px solid transparent;
}

.thumbnail-img.selected {
  border: 2px solid #d2042d !important;
}

.thumbnail-img:hover {
  transform: scale(1.1);
}

.time-square-billboard {
  width: 35%;
  background-color: white;
  padding: 0px;

  margin-left: 4%;
  position: relative;
  top: -10px;
}

.billboard-product-id {
  color: #d2042d;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-size: 13px;
}
.billboard-tittle {
  font-family: Roboto;
  font-size: 19px;
  font-weight: 600;
}

.billboard-tittle-name {
  color: #000;
  font-size: 19px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.row-spacing {
  margin-bottom: 20px;
}

.billboard-table-name {
  font-weight: bold;
  text-align: left;
  padding: 8px;
}

.col-billboard-table-value {
  font-family: Roboto;
  align-self: stretch;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.time-square-billboard-table {
  margin: 20px auto;
  height: 550px;
  overflow-y: auto;
  padding-right: 10px;
}

.time-square-billboard-table::-webkit-scrollbar {
  width: 6px;
  display: block;
}

.time-square-billboard-table::-webkit-scrollbar-thumb {
  background-color: lightcoral;
  border-radius: 10px;
}

.time-square-billboard-table::-webkit-scrollbar-track {
  background-color: #f0f0f0;
}

.billboard-map-btn {
  color: var(--Colors-Primary-500, #d2042d);

  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  margin-left: 10px;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.billboard-map-btn:hover {
  text-decoration: underline;
}

.col-heading {
  font-family: Roboto;
  align-self: stretch;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.col-billboard-value {
  align-self: stretch;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.time-square-billboard-calendar {
  padding: 0 1.5rem 0 1.5rem;
  flex: 1 1;
  width: 20%;
}

.billboard-calendar-container {
  max-width: 200px;
  margin: auto;
  padding: 20px;
}

.billboard-calendar-title {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.calendar-message-paragraph {
  font-size: 16px;
  font-weight: 400;
  color: #3b3f3d;
  line-height: 1.5;
  word-wrap: break-word;
  margin-inline-start: 1rem;
}

.campaign-popover.ant-popover-content {
  margin-left: 75% !important;
  width: 21.1875rem !important;
  height: 8.8125rem !important;
}

.custom-new-campaign-popover {
  z-index: 1050 !important;
  position: fixed;
  top: 100px;
}

.calendar-single {
  max-width: 339px !important;
  width: 100% !important;
}

.calendar-single .ant-picker-panel-container .ant-picker-date-panel-container {
  box-shadow: none !important;
  border-radius: 12.133px;
}

.datepicker-container .ant-picker-dropdown .ant-picker-cell-disabled::before {
  background: none;
}

.notify-section-text {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  margin-bottom: 6px;
}
.not-available-text {
  font-size: 14px;
  line-height: 26.6px;
  color: #d2042d;
}
.book-it-text {
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 25px;
}
.drop-text-label {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
}
.login-to-access-campaign-popover-div {
  text-align: center !important;
  width: 100%;
}

.login-to-access-campaign-popover-tittle.ant-typography {
  font-family: Montserrat;
  color: #000;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  font-family: "Montserrat";
}

.login-to-access-campaign-popover-text-div {
  width: 36.4375rem;
  text-align: center;
  /* margin-top: 2% !important; */
  display: flex;
  flex-direction: column;
  align-content: center;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding: 10px 25px;
  margin-left: 35px;
}

.login-to-access-campaign-popover-text.ant-typography {
  font-family: Roboto !important;
  color: #000;
  text-align: center !important;
  font-size: 14px;
  font-style: normal;
  /* max-width: 480px; */
  font-weight: 400;
  line-height: 1.78125rem;
}

.login-to-access-campaign-popover-lgn-btn-div {
  display: flex;
  justify-content: center;
}

.login-to-access-campaign-popover-lgn-btn {
  font-family: Roboto;
  display: flex;
  margin-top: 4%;
  width: 13.25rem;
  height: 3.125rem;
  padding: 0.5rem 3.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #d2042d;
}

.login-to-access-campaign-popover-lgn-btn.ant-btn-color-default {
  color: white !important;
}

.login-to-access-campaign-popover-lgn-btn.ant-btn:not(:disabled):focus-visible {
  outline: none !important;
  outline-offset: none !important;
  transition: none !important;
}

.login-to-access-campaign-popover-lgn-btn-div
  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: none !important;
}

.addtocampain-container {
  width: 100% !important;
  max-width: 100%;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.addtocampain-rightside-data {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.addto-campain-footer {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top: 1px solid #e4e4e4;
  background: #fff;
  margin-top: 2rem;
  width: 100%;
  height: auto;
  min-height: 100px;
  padding: 0 20px;
}

.price-paragraph-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}

.campaign-price {
  font-family: Roboto;
  font-size: 23px;
  font-weight: 800;
  color: #d2042d;
  text-align: right;
  margin-bottom: 5px;
}

.addtocampain-paragraph {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  text-align: end;
  color: #5b5e5d;
  line-height: 18.2px;
  margin-bottom: 0 !important;
}

.addtocampain-button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex-grow: 1;
}

.addto-campain-btn,
.addto-campain-btn:not(.disabled-button):hover {
  font-family: Roboto;
  min-width: 180px;
  height: 40px;
  background: #d2042d;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.addto-campain-btn.disabled-button {
  background-color: #d9d9d9 !important;
  color: #a6a6a6 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}
.login-to-access-campaign-popover-lgn-btn:hover {
  background-color: #d2042d;
}
.addto-campain-btn:not(.disable-add-tocart):hover {
  background-color: #d2042d !important;
}
.disable-add-tocart:hover {
  /* color: #fff ; */
  color: #a6a6a6 !important;
  background: #d9d9d9 !important;
  opacity: 0.5;
  cursor: not-allowed !important;
}
.view-on-map-addrs-2 {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 1rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  margin-left: 10px;
  cursor: pointer;
}
.main-product-img .google-map-container {
  width: 100% !important;
}
.notify-badge {
  font-family: Roboto;
  font-style: Regular;
  line-height: 100%;
  letter-spacing: 0%;
}
.notify-badge .ant-badge-count {
  padding: 8px;
  border-radius: 30px;
  height: 31px;
  width: 155px;
  font-weight: 400;
  font-size: 13px;
  color: #d2042d;
  background-color: #ffd9e1;
}
@media (max-width: 768px) {
  .addtocampain-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .addtocampain-rightside-data {
    align-items: center;
    text-align: center;
    width: 100%;
  }

  .campaign-price {
    text-align: center;
    margin-right: 0;
  }

  .addtocampain-paragraph {
    text-align: center;
  }

  .addtocampain-button-container {
    justify-content: center;
    width: 100%;
    margin-top: 10px;
  }

  .addto-campain-btn {
    width: 100%;
    max-width: 250px;
  }
}
@media (max-width: 1024px) {
  .product-image-container {
    width: 25%;
    margin-inline-start: 2%;
  }

  .main-product-img .ant-image .ant-image-img {
    max-width: 200px;
    max-height: 200px;
  }

  .thumbnail-img {
    max-width: 45px !important;
    max-height: 45px !important;
  }

  .time-square-billboard-table {
    margin: 20px auto;
    max-height: 415px !important;
    overflow-y: auto;
    padding-right: 10px;
  }

  .col-heading {
    font-size: 14px;
    font-weight: 250px;
  }
  .view-on-map-addrs-2 {
    font-size: 14px;
    font-weight: 250px;
  }
  .col-billboard-table-value {
    font-weight: 250px;
  }

  .row-spacing {
    margin-bottom: 15px;
  }

  .billboard-map-btn {
    font-size: 11px;
    font-weight: 300px;
  }

  .billboard-calendar-title {
    font-size: 16px;
    font-weight: 350;
    line-height: 1;
    margin-bottom: 8px;
    word-wrap: break-word;
  }

  .select-date-text {
    font-size: 12px;
    font-weight: 250px;
  }

  .calendar-message-paragraph {
    display: flex;
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin: 0;
  }

  .calendar-description {
    text-wrap: inherit;
    color: #373737;
    font-size: var(--Font-Font-Size-p, 12px);
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  .minimum-dates {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: var(--Font-Font-Size-p, 12px);
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  .calendar-single {
    width: 20% !important;
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
    max-width: 275px !important;
    height: auto !important;
  }

  .total-selected-days {
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    margin-left: 1.5rem;
  }

  .calendar-single
    .ant-picker-panel-container
    .ant-picker-date-panel-container {
    box-shadow: none !important;
    border-radius: 12.133px;
  }

  .login-to-access-campaign-popover-div {
    max-width: 100%;
  }

  .login-to-access-campaign-popover-tittle.ant-typography {
    color: #000;
    font-family: "Montserrat";
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    max-width: 100%;
  }

  .login-to-access-campaign-popover-text-div {
    max-width: 100%;
    text-align: center;
  }

  .custom-new-campaign-popover {
    margin-left: 75%;
    width: 12rem;
    position: fixed !important;
  }

  .login-to-access-campaign-popover-text.ant-typography {
    color: #000;
    text-align: center !important;
    font-size: 16px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    max-width: 450px;
  }

  .login-to-access-campaign-popover-lgn-btn-div {
    display: flex;
    justify-content: center;
  }

  .login-to-access-campaign-popover-lgn-btn {
    display: flex;
    margin-top: 4%;
    max-width: 100%;
    max-height: 100%;
    padding: 0.5rem 3.75rem;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
    border-radius: 0.3125rem;
    background: #d2042d;
  }

  .custom-calendar .ant-picker-clear {
    display: none;
  }

  .custom-calendar:hover .ant-picker-clear {
    opacity: 1 !important;
  }

  .addto-campain-footer {
    border-top: 1px solid #e4e4e4;
    background: #fff;
    margin-top: 2rem;
    width: 100%;
    height: 100px;
    min-height: 100px;
    padding: 0 20px;
  }

  .addto-campain-footer {
    flex-direction: row;
    height: auto;
    padding: 10px 20px;
  }

  .addtocampain-container {
    align-items: center;
  }

  .addtocampain-rightside-data,
  .addtocampain-button-container {
    width: 100%;
    text-align: center;
    justify-content: center;
  }

  .campaign-price {
    text-align: center;
  }

  .addtocampain-paragraph {
    text-align: center;
    margin-left: 0;
  }

  .addto-campain-btn {
    width: 100%;
    max-width: 300px;
    margin: 10px auto;
  }

  .campaign-popover .ant-popover .ant-popover-content {
    width: 195px;
    inset-inline-start: 4.5rem;
  }
}

@media (max-width: 500px) {
  .login-to-access-campaign-popover-text.ant-typography {
    margin-left: 0;
    max-width: 350px;
  }
  .login-to-access-campaign-popover-text-div {
    margin-left: 0 !important;
  }
}
.datepicker-container {
  height: 21.87231rem !important;
  flex-shrink: 0 !important;
  position: relative;
}

.ant-picker-dropdown .datepicker-container .ant-picker-selector {
  display: none !important;
}

.datepicker-container.ant-picker-date-panel {
  width: 100% !important;
}

:where(.css-dev-only-do-not-override-cdzvx5).ant-picker-dropdown
  .ant-picker-date-panel,
:where(.css-dev-only-do-not-override-cdzvx5).ant-picker-dropdown
  .ant-picker-time-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.datepicker-container.ant-picker-dropdown {
  font-size: 20px !important;
}

.custom-calendar-popup .ant-picker-panel-container {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  height: auto !important;
  flex-shrink: 0;
  box-shadow: none;
  border-radius: 12.133px;
  border: 1.213px solid #ddd;
  background: #fff;
  caret-color: transparent !important;
  font-size: 15.196px;
  font-style: normal;
  font-weight: 500;
  position: absolute;
  overflow: hidden;
}

.datepicker-container .ant-picker-selector {
  display: none !important;
}

.custom-calendar-popup {
  width: 100% !important;
  inset: 58% auto auto 88.5%;
}

.custom-calendar.ant-picker-outlined {
  border: none !important;
  justify-content: end;
  padding: 0;
  margin: 0;
}

.custom-calendar.ant-picker .ant-picker-suffix {
  display: flex;
  flex: none;
  align-self: center;
  margin-inline-start: 4px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1;
  pointer-events: none;
  transition:
    opacity 0.2s,
    color 0.2s;
  display: none;
}

.custom-calendar-popup .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.custom-calendar-popup .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #d2042d !important;
  color: white !important;
  border: #d2042d !important;
}

.custom-calendar-popup .ant-picker-cell-today .ant-picker-cell-inner::before {
  border: none !important;
}

.custom-calendar-popup .ant-picker-cell-today .ant-picker-cell-inner {
  border: 1px solid #d2042d !important;
}

.custom-calendar-popup
  .ant-picker-dropdown
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  border: none !important;
}

.calendar-selected-dates-container {
  margin-top: 2rem;
  margin-inline-start: -0.7rem;
}

.selected-days-heading {
  font-family: Roboto;
  color: var(--Colors-Text-300, #5b5e5d);
  margin-top: 100px;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 1rem;
}

.datepicker-container .ant-picker .ant-picker-clear > * {
  vertical-align: top;
  display: none;
}

.total-selected-days {
  font-family: Roboto;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 1rem;
}

.select-campaign-dropdown {
  font-family: Roboto;
  display: flex;
  height: 50px;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);
  background: #fcfcfc;
}

.select-campaign-div .ant-select .ant-select-arrow {
  color: #000;
  width: 14px;
  height: 7px;
  flex-shrink: 0;
  stroke-width: 2px;

  stroke: var(--Colors-Text-300, #5b5e5d);
}
.select-campaign-div {
  padding-top: 10px;
}
.select-campaign-label {
  font-weight: 500;
}

.custom-new-campaign-drawer .ant-drawer-content-wrapper {
  width: 20% !important;
  box-shadow: none !important;
}

.ant-drawer-top.custom-new-campaign-drawer > .ant-drawer-content-wrapper {
  box-shadow: none !important;
}

:where(.css-dev-only-do-not-override-cdzvx5).ant-drawer .ant-drawer-mask {
  position: absolute;
  inset: 0;
  z-index: 1000;
  background: none !important;
  pointer-events: auto;
}

.dropdown-achor-tag {
  color: #6a6a6a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.select-campain-hover.a:hover {
  background-color: transparent !important;
}

.custom-new-campaign-popover {
  margin-left: 75%;
  width: 17% !important;
  position: fixed !important;
}

.user-campaign-list {
  height: 19rem !important;
  overflow-y: scroll;
  overflow-x: hidden;
  cursor: pointer;
}

.user-campaign-list::-webkit-scrollbar {
  display: flex;
}

.dropdown-main-menu
  .ant-menu-item
  .ant-menu-item-selected
  .ant-menu-item-only-child
  .dropdown-main-menu-items {
  font-family: Roboto;
  background-color: none !important;
}

.dropdown-main-menu .dropdown-main-menu-create-campaign-btn {
  position: sticky;
  z-index: 1;
}

.dropdown-main-menu
  :where(.css-dev-only-do-not-override-cdzvx5).ant-menu-light
  .ant-menu-item-selected {
  background-color: white;
}

.dropdown-main-menu .ant-menu-light.ant-menu-root.ant-menu-vertical {
  border-inline-end: none;
}

.user-campaign-list .ant-menu-item:hover {
  background-color: #d2042d !important;
  color: white !important;
}

.create-campaign-btn {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.dropdown-main-menu-items .ant-menu-title-content {
  font-family: Roboto;
}

.dropdown-main-menu-items.ant-dropdown-menu-vertical {
  font-family: Roboto;
  overflow-y: none;
}

.user-campaign-list .ant-menu-item {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  align-items: center;
}

.dropdown-main-menu-btn {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  border: none !important;
  background: transparent !important;
}

.dropdown-main-menu-btn:hover,
.dropdown-main-menu-btn:focus,
.dropdown-main-menu-btn:active {
  color: inherit !important;
  background: transparent !important;
  border: none !important;
  outline: none !important;
}

.dropdown-main-menu-btn .ant-menu .ant-menu-item-selected {
  background-color: none !important;
  color: none !important;
}

.dropdown-main-menu-btn
  .ant-menu-light:not(.ant-menu-horizontal)
  .ant-menu-item:not(.ant-menu-item-selected):hover {
  background-color: unset !important;
}

.ant-popover-arrow {
  display: none !important;
}

.create-new-campaign-btn-parent .ant-btn:hover {
  background-color: transparent !important;
  background: none !important;
}

.addto-campaign-name-modal {
  border-radius: 10px;
  background: #fff;
  padding: 5px 0px 0px 11px;
}

.addto-campaign-name-text {
  margin-top: 3% !important;
}

.addto-campaign-name-text {
  display: flex;
  width: 295px;
  height: 50px;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);
  background: #fcfcfc;
  border-left: 1px;
}

.addto-campaign-save-btn {
  font-family: Roboto;
  display: flex;
  width: 100%;
  height: 43px;
  padding: 12px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  margin-top: 5%;
  color: white !important;
  text-decoration: none !important;
}

.addto-campaign-save-btn:hover,
.addto-campaign-save-btn:focus,
.addto-campaign-save-btn:active {
  background: var(--Colors-Primary-500, #d2042d) !important;
  color: white !important;
  border: none !important;
  box-shadow: none !important;
  text-decoration: none !important;
}
.go-back-parent {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.addto-campaign-goback-btn {
  font-family: Roboto;
  display: flex;
  height: 43px;
  padding: 12px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  margin-top: -1rem;
}
.go-back-parent .ant-btn-color-link.ant-btn-variant-link {
  color: #d2042d !important;
  box-shadow: none;
}

.addto-campaign-goback-btn:hover,
.addto-campaign-goback-btn:active,
.addto-campaign-goback-btn:focus {
  color: #d2042d !important;
}

.create-new-campaign-popover.ant-popover-content {
  width: 20% !important;
}

.billBoard-popUp-calendar .ant-picker-panels > *:nth-child(2) {
  display: none;
}

.billBoard-popUp-calendar
  .ant-picker-panel:first-child
  .ant-picker-header-next-btn,
.billBoard-popUp-calendar
  .ant-picker-panel:first-child
  .ant-picker-header-super-next-btn {
  visibility: visible !important;
}

.billBoard-popUp-calendar
  .ant-picker-panel:last-child
  .ant-picker-header-next-btn,
.billBoard-popUp-calendar
  .ant-picker-panel:last-child
  .ant-picker-header-super-next-btn {
  visibility: hidden !important;
}

.custom-calendar-popup .ant-picker-panel-container {
  display: flex;
}

.custom-calendar-popup
  .ant-picker-panel:first-child
  .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:first-child
  .ant-picker-header-super-next-btn {
  visibility: visible !important;
}

.custom-calendar-popup .ant-picker-panels > div:nth-child(2) {
  display: none !important;
}

.custom-calendar-popup .ant-picker-panel:last-child .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:last-child
  .ant-picker-header-super-next-btn {
  visibility: hidden !important;
}
.custom-cell.start-date,
.custom-cell.end-date {
  background-color: #d2042d;
  color: white;
}

.custom-calendar input {
  display: none !important;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(
    .ant-picker-cell-disabled
  ):before,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
    .ant-picker-cell-disabled
  ):before,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  ):before {
  background-color: transparent !important;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-in-range
  .ant-picker-cell-inner,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-start
  .ant-picker-cell-inner,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-end
  .ant-picker-cell-inner {
  color: white !important;
}
.login-to-access-campaign-popover-lgn-btn:hover {
  color: white !important;
  background-color: #d2042d !important;
  border-color: #d2042d !important;
}
.create-new-campaign-popover.ant-modal .ant-modal-body {
  margin-top: 10%;
}
.login-to-access-campaign-popover .ant-modal-content {
  padding: 60px 16px !important;
}

.custom-calendar-popup .ant-picker-panel-container {
  display: flex;
}

.custom-calendar-popup
  .ant-picker-panel:first-child
  .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:first-child
  .ant-picker-header-super-next-btn {
  visibility: visible !important;
}

.custom-calendar-popup .ant-picker-panels > div:nth-child(2) {
  display: none !important;
}

.custom-calendar-popup
  .ant-picker-panel:first-child
  .ant-picker-header-next-btn,
.custom-calendar-popup
  .ant-picker-panel:first-child
  .ant-picker-header-super-next-btn {
  visibility: visible !important;
}

.custom-calendar-arrows
  .ant-picker-panel:last-child
  .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:last-child
  .ant-picker-header-super-next-btn {
  visibility: hidden !important;
}

.custom-cell.start-date,
.custom-cell.end-date {
  background-color: #d2042d;
  color: white;
}

.custom-calendar input {
  display: none !important;
}

.custom-cell {
  width: 65%;
  height: 100%;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(
    .ant-picker-cell-disabled
  ):before,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(
    .ant-picker-cell-disabled
  ):before,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(
    .ant-picker-cell-disabled
  ):before {
  border-radius: 0.4rem;
  background-color: #e7002e2d !important;
}

.custom-calendar-popup tr {
  display: flex;
  justify-content: space-between !important;
  gap: 0.5rem !important;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-in-range
  .ant-picker-cell-inner,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-start
  .ant-picker-cell-inner,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-end
  .ant-picker-cell-inner {
  color: white !important;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-start
  .ant-picker-cell-inner {
  background-color: #d2042d !important;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-end
  .ant-picker-cell-inner {
  background-color: #d2042d !important;
}

.custom-cell.disabled {
  color: #ccc;
  pointer-events: none;
  background: #f5f5f5;
}

.custom-calendar-popup .ant-picker-panel-container {
  display: flex;
}

.custom-calendar-popup
  .ant-picker-panel:first-child
  .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:first-child
  .ant-picker-header-super-next-btn {
  visibility: visible !important;
}

.custom-calendar-popup .ant-picker-panels > div:nth-child(2) {
  display: none !important;
}

.custom-cell.in-range {
  background-color: #d2042d;
  color: white;
}

.custom-cell.start-date,
.custom-cell.end-date {
  background-color: #d2042d;
  color: white;
}

.custom-calendar input {
  display: none !important;
}

.custom-cell {
  width: 100%;
  height: 100%;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-in-range
  .ant-picker-cell-inner,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-start
  .ant-picker-cell-inner,
.custom-calendar-popup
  .ant-picker-cell-in-view.ant-picker-cell-range-end
  .ant-picker-cell-inner {
  color: white !important;
}
.login-to-access-campaign-popover-lgn-btn:hover {
  color: white !important;
  background-color: #d2042d !important;
  border-color: #d2042d !important;
}
.create-new-campaign-popover.ant-modal .ant-modal-body {
  margin-top: 10%;
}
.login-to-access-campaign-popover .ant-modal-content {
  padding: 60px 16px !important;
}
.product-modal-spin {
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-model-menu-empty {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 20px;
  font-weight: 200px;
  font-style: normal;
}
.addto-campain-footer-sub-div {
  display: flex;
  align-items: center;
  gap: 2rem;
}
/* @media (max-width: 500) {
  .custom-calendar-popup tr {
    gap: 1.2rem !important;
  }
} */
/* @media (max-width: 768) {
  .custom-calendar-popup tr {
    display: flex;
    justify-content: space-between !important;
    gap: -1.5rem !important;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/components/modal/product-detail-modal/ProductModalPopUp.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,yCAAyC;EACzC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;;EAEjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,mDAAmD;EACnD,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB;;8BAE4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,YAAY;;EAEZ,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;;EAEzC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;IACzC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;;;IAGE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;EACpB;;cAEY;EACZ,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,cAAc;EACd,iBAAiB;;EAEjB,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;;;EAGE,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;;EAGE,yDAAyD;EACzD,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,6BAA6B;AAC/B;AACA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;EAYE,wCAAwC;AAC1C;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;;;GAIG;AACH;;;;;;GAMG","sourcesContent":[".ant-modal {\n  box-shadow: none !important;\n}\n\n.product-modal-container {\n  width: 100% !important;\n}\n\n.product-container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-top: 2rem;\n  position: relative;\n  width: 100%;\n}\n.view-btn-parent .ant-btn-color-link.ant-btn-variant-link {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.view-on-map {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.view-btn-parent .ant-btn-color-link.ant-btn-variant-link {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.view-on-map {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.multi-slot-dates-table {\n  max-height: 20vh !important;\n  overflow-y: auto !important;\n}\n.product-image-container {\n  width: 35%;\n  margin-inline-start: 2%;\n}\n\n.product-image-container img {\n  max-height: 470px;\n\n  margin-top: -2%;\n  display: flex;\n}\n\n.main-product-img .ant-image {\n  width: 100%;\n}\n\n.main-product-img .ant-image .ant-image-img {\n  width: 100%;\n  height: 500px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: lightgray 50% / cover no-repeat;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n.google-map-container {\n  background: lightgray 50% / cover no-repeat;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n}\n.thumbnail-img.active-thumbnail {\n  border: 1px solid #d2042d; /* or your theme color */\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n}\n.select-date-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin-inline-start: 1rem;\n}\n\n.calendar-message-paragraph {\n  font-family: Roboto;\n  display: flex;\n  padding: 10px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 10px;\n  background: #f5f5f5;\n}\n.menu-items-product-modal {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n.menu-items-campaign-names {\n  color: \"var(--Colors-Text-500, #0A0F0D)\" !important;\n  font-size: 20px !important;\n  font-weight: 200px !important;\n  font-style: normal !important;\n}\n.add-to-campaign-footer-second {\n  display: flex !important;\n  align-items: center !important;\n  gap: 2rem !important;\n}\n.calendar-description {\n  font-family: Roboto;\n  text-wrap: inherit;\n  color: #373737;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.minimum-dates {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n}\n\n.ant-picker-footer {\n  display: none;\n}\n\n.custom-datepicker .ant-picker-panel-layout {\n  flex-shrink: 0;\n  position: absolute !important;\n  border-radius: 12.133px;\n  border: 1.213px solid #ddd;\n  background: #fff;\n  margin-inline-start: 1rem;\n}\n\n.hidden-date-picker .ant-picker-input {\n  display: none !important;\n}\n\n.hidden-date-picker.ant-picker-outlined {\n  border-style: none !important;\n}\n\n.bookamark-icon {\n  position: absolute;\n}\n\n.bookmark-icon:hover {\n  transform: scale(1.2);\n}\n\n.image-thumbnail-row {\n  margin-top: 8%;\n}\n\n.thumbnail-img {\n  cursor: pointer;\n  width: 72px !important;\n  height: 72px !important;\n  border-radius: 10px;\n  display: flex !important;\n  margin-right: 0.8rem;\n  margin-top: 10px;\n  position: relative;\n  transition:\n    border 0.2s ease-in-out,\n    transform 0.2s ease-in-out;\n  border: 2px solid transparent;\n}\n\n.thumbnail-img.selected {\n  border: 2px solid #d2042d !important;\n}\n\n.thumbnail-img:hover {\n  transform: scale(1.1);\n}\n\n.time-square-billboard {\n  width: 35%;\n  background-color: white;\n  padding: 0px;\n\n  margin-left: 4%;\n  position: relative;\n  top: -10px;\n}\n\n.billboard-product-id {\n  color: #d2042d;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-size: 13px;\n}\n.billboard-tittle {\n  font-family: Roboto;\n  font-size: 19px;\n  font-weight: 600;\n}\n\n.billboard-tittle-name {\n  color: #000;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.row-spacing {\n  margin-bottom: 20px;\n}\n\n.billboard-table-name {\n  font-weight: bold;\n  text-align: left;\n  padding: 8px;\n}\n\n.col-billboard-table-value {\n  font-family: Roboto;\n  align-self: stretch;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.time-square-billboard-table {\n  margin: 20px auto;\n  height: 550px;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n.time-square-billboard-table::-webkit-scrollbar {\n  width: 6px;\n  display: block;\n}\n\n.time-square-billboard-table::-webkit-scrollbar-thumb {\n  background-color: lightcoral;\n  border-radius: 10px;\n}\n\n.time-square-billboard-table::-webkit-scrollbar-track {\n  background-color: #f0f0f0;\n}\n\n.billboard-map-btn {\n  color: var(--Colors-Primary-500, #d2042d);\n\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  margin-left: 10px;\n  line-height: 24px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n\n.billboard-map-btn:hover {\n  text-decoration: underline;\n}\n\n.col-heading {\n  font-family: Roboto;\n  align-self: stretch;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.col-billboard-value {\n  align-self: stretch;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.time-square-billboard-calendar {\n  padding: 0 1.5rem 0 1.5rem;\n  flex: 1;\n  width: 20%;\n}\n\n.billboard-calendar-container {\n  max-width: 200px;\n  margin: auto;\n  padding: 20px;\n}\n\n.billboard-calendar-title {\n  font-size: 19px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 10px;\n  word-wrap: break-word;\n}\n\n.calendar-message-paragraph {\n  font-size: 16px;\n  font-weight: 400;\n  color: #3b3f3d;\n  line-height: 1.5;\n  word-wrap: break-word;\n  margin-inline-start: 1rem;\n}\n\n.campaign-popover.ant-popover-content {\n  margin-left: 75% !important;\n  width: 21.1875rem !important;\n  height: 8.8125rem !important;\n}\n\n.custom-new-campaign-popover {\n  z-index: 1050 !important;\n  position: fixed;\n  top: 100px;\n}\n\n.calendar-single {\n  max-width: 339px !important;\n  width: 100% !important;\n}\n\n.calendar-single .ant-picker-panel-container .ant-picker-date-panel-container {\n  box-shadow: none !important;\n  border-radius: 12.133px;\n}\n\n.datepicker-container .ant-picker-dropdown .ant-picker-cell-disabled::before {\n  background: none;\n}\n\n.notify-section-text {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  margin-bottom: 6px;\n}\n.not-available-text {\n  font-size: 14px;\n  line-height: 26.6px;\n  color: #d2042d;\n}\n.book-it-text {\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  margin-top: 25px;\n}\n.drop-text-label {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0%;\n}\n.login-to-access-campaign-popover-div {\n  text-align: center !important;\n  width: 100%;\n}\n\n.login-to-access-campaign-popover-tittle.ant-typography {\n  font-family: Montserrat;\n  color: #000;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-align: center;\n  font-family: \"Montserrat\";\n}\n\n.login-to-access-campaign-popover-text-div {\n  width: 36.4375rem;\n  text-align: center;\n  /* margin-top: 2% !important; */\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 25px;\n  margin-left: 35px;\n}\n\n.login-to-access-campaign-popover-text.ant-typography {\n  font-family: Roboto !important;\n  color: #000;\n  text-align: center !important;\n  font-size: 14px;\n  font-style: normal;\n  /* max-width: 480px; */\n  font-weight: 400;\n  line-height: 1.78125rem;\n}\n\n.login-to-access-campaign-popover-lgn-btn-div {\n  display: flex;\n  justify-content: center;\n}\n\n.login-to-access-campaign-popover-lgn-btn {\n  font-family: Roboto;\n  display: flex;\n  margin-top: 4%;\n  width: 13.25rem;\n  height: 3.125rem;\n  padding: 0.5rem 3.75rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #d2042d;\n}\n\n.login-to-access-campaign-popover-lgn-btn.ant-btn-color-default {\n  color: white !important;\n}\n\n.login-to-access-campaign-popover-lgn-btn.ant-btn:not(:disabled):focus-visible {\n  outline: none !important;\n  outline-offset: none !important;\n  transition: none !important;\n}\n\n.login-to-access-campaign-popover-lgn-btn-div\n  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n  background-color: none !important;\n}\n\n.addtocampain-container {\n  width: 100% !important;\n  max-width: 100%;\n  flex-wrap: wrap;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.addtocampain-rightside-data {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.addto-campain-footer {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  border-top: 1px solid #e4e4e4;\n  background: #fff;\n  margin-top: 2rem;\n  width: 100%;\n  height: auto;\n  min-height: 100px;\n  padding: 0 20px;\n}\n\n.price-paragraph-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 100%;\n}\n\n.campaign-price {\n  font-family: Roboto;\n  font-size: 23px;\n  font-weight: 800;\n  color: #d2042d;\n  text-align: right;\n  margin-bottom: 5px;\n}\n\n.addtocampain-paragraph {\n  font-family: Roboto;\n  font-size: 13px;\n  font-weight: 400;\n  text-align: end;\n  color: #5b5e5d;\n  line-height: 18.2px;\n  margin-bottom: 0 !important;\n}\n\n.addtocampain-button-container {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  flex-grow: 1;\n}\n\n.addto-campain-btn,\n.addto-campain-btn:not(.disabled-button):hover {\n  font-family: Roboto;\n  min-width: 180px;\n  height: 40px;\n  background: #d2042d;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.addto-campain-btn.disabled-button {\n  background-color: #d9d9d9 !important;\n  color: #a6a6a6 !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n}\n.login-to-access-campaign-popover-lgn-btn:hover {\n  background-color: #d2042d;\n}\n.addto-campain-btn:not(.disable-add-tocart):hover {\n  background-color: #d2042d !important;\n}\n.disable-add-tocart:hover {\n  /* color: #fff ; */\n  color: #a6a6a6 !important;\n  background: #d9d9d9 !important;\n  opacity: 0.5;\n  cursor: not-allowed !important;\n}\n.view-on-map-addrs-2 {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 1rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  margin-left: 10px;\n  cursor: pointer;\n}\n.main-product-img .google-map-container {\n  width: 100% !important;\n}\n.notify-badge {\n  font-family: Roboto;\n  font-style: Regular;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n.notify-badge .ant-badge-count {\n  padding: 8px;\n  border-radius: 30px;\n  height: 31px;\n  width: 155px;\n  font-weight: 400;\n  font-size: 13px;\n  color: #d2042d;\n  background-color: #ffd9e1;\n}\n@media (max-width: 768px) {\n  .addtocampain-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .addtocampain-rightside-data {\n    align-items: center;\n    text-align: center;\n    width: 100%;\n  }\n\n  .campaign-price {\n    text-align: center;\n    margin-right: 0;\n  }\n\n  .addtocampain-paragraph {\n    text-align: center;\n  }\n\n  .addtocampain-button-container {\n    justify-content: center;\n    width: 100%;\n    margin-top: 10px;\n  }\n\n  .addto-campain-btn {\n    width: 100%;\n    max-width: 250px;\n  }\n}\n@media (max-width: 1024px) {\n  .product-image-container {\n    width: 25%;\n    margin-inline-start: 2%;\n  }\n\n  .main-product-img .ant-image .ant-image-img {\n    max-width: 200px;\n    max-height: 200px;\n  }\n\n  .thumbnail-img {\n    max-width: 45px !important;\n    max-height: 45px !important;\n  }\n\n  .time-square-billboard-table {\n    margin: 20px auto;\n    max-height: 415px !important;\n    overflow-y: auto;\n    padding-right: 10px;\n  }\n\n  .col-heading {\n    font-size: 14px;\n    font-weight: 250px;\n  }\n  .view-on-map-addrs-2 {\n    font-size: 14px;\n    font-weight: 250px;\n  }\n  .col-billboard-table-value {\n    font-weight: 250px;\n  }\n\n  .row-spacing {\n    margin-bottom: 15px;\n  }\n\n  .billboard-map-btn {\n    font-size: 11px;\n    font-weight: 300px;\n  }\n\n  .billboard-calendar-title {\n    font-size: 16px;\n    font-weight: 350;\n    line-height: 1;\n    margin-bottom: 8px;\n    word-wrap: break-word;\n  }\n\n  .select-date-text {\n    font-size: 12px;\n    font-weight: 250px;\n  }\n\n  .calendar-message-paragraph {\n    display: flex;\n    width: 100%;\n    padding: 0px 20px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n  }\n\n  .calendar-description {\n    text-wrap: inherit;\n    color: #373737;\n    font-size: var(--Font-Font-Size-p, 12px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n  }\n\n  .minimum-dates {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: var(--Font-Font-Size-p, 12px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n  }\n\n  .calendar-single {\n    width: 20% !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: center !important;\n    align-items: center !important;\n    max-width: 275px !important;\n    height: auto !important;\n  }\n\n  .total-selected-days {\n    color: #000;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: normal;\n    margin-left: 1.5rem;\n  }\n\n  .calendar-single\n    .ant-picker-panel-container\n    .ant-picker-date-panel-container {\n    box-shadow: none !important;\n    border-radius: 12.133px;\n  }\n\n  .login-to-access-campaign-popover-div {\n    max-width: 100%;\n  }\n\n  .login-to-access-campaign-popover-tittle.ant-typography {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-align: center;\n    max-width: 100%;\n  }\n\n  .login-to-access-campaign-popover-text-div {\n    max-width: 100%;\n    text-align: center;\n  }\n\n  .custom-new-campaign-popover {\n    margin-left: 75%;\n    width: 12rem;\n    position: fixed !important;\n  }\n\n  .login-to-access-campaign-popover-text.ant-typography {\n    color: #000;\n    text-align: center !important;\n    font-size: 16px;\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n    max-width: 450px;\n  }\n\n  .login-to-access-campaign-popover-lgn-btn-div {\n    display: flex;\n    justify-content: center;\n  }\n\n  .login-to-access-campaign-popover-lgn-btn {\n    display: flex;\n    margin-top: 4%;\n    max-width: 100%;\n    max-height: 100%;\n    padding: 0.5rem 3.75rem;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n    border-radius: 0.3125rem;\n    background: #d2042d;\n  }\n\n  .custom-calendar .ant-picker-clear {\n    display: none;\n  }\n\n  .custom-calendar:hover .ant-picker-clear {\n    opacity: 1 !important;\n  }\n\n  .addto-campain-footer {\n    border-top: 1px solid #e4e4e4;\n    background: #fff;\n    margin-top: 2rem;\n    width: 100%;\n    height: 100px;\n    min-height: 100px;\n    padding: 0 20px;\n  }\n\n  .addto-campain-footer {\n    flex-direction: row;\n    height: auto;\n    padding: 10px 20px;\n  }\n\n  .addtocampain-container {\n    align-items: center;\n  }\n\n  .addtocampain-rightside-data,\n  .addtocampain-button-container {\n    width: 100%;\n    text-align: center;\n    justify-content: center;\n  }\n\n  .campaign-price {\n    text-align: center;\n  }\n\n  .addtocampain-paragraph {\n    text-align: center;\n    margin-left: 0;\n  }\n\n  .addto-campain-btn {\n    width: 100%;\n    max-width: 300px;\n    margin: 10px auto;\n  }\n\n  .campaign-popover .ant-popover .ant-popover-content {\n    width: 195px;\n    inset-inline-start: 4.5rem;\n  }\n}\n\n@media (max-width: 500px) {\n  .login-to-access-campaign-popover-text.ant-typography {\n    margin-left: 0;\n    max-width: 350px;\n  }\n  .login-to-access-campaign-popover-text-div {\n    margin-left: 0 !important;\n  }\n}\n.datepicker-container {\n  height: 21.87231rem !important;\n  flex-shrink: 0 !important;\n  position: relative;\n}\n\n.ant-picker-dropdown .datepicker-container .ant-picker-selector {\n  display: none !important;\n}\n\n.datepicker-container.ant-picker-date-panel {\n  width: 100% !important;\n}\n\n:where(.css-dev-only-do-not-override-cdzvx5).ant-picker-dropdown\n  .ant-picker-date-panel,\n:where(.css-dev-only-do-not-override-cdzvx5).ant-picker-dropdown\n  .ant-picker-time-panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.datepicker-container.ant-picker-dropdown {\n  font-size: 20px !important;\n}\n\n.custom-calendar-popup .ant-picker-panel-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center !important;\n  align-items: center !important;\n  height: auto !important;\n  flex-shrink: 0;\n  box-shadow: none;\n  border-radius: 12.133px;\n  border: 1.213px solid #ddd;\n  background: #fff;\n  caret-color: transparent !important;\n  font-size: 15.196px;\n  font-style: normal;\n  font-weight: 500;\n  position: absolute;\n  overflow: hidden;\n}\n\n.datepicker-container .ant-picker-selector {\n  display: none !important;\n}\n\n.custom-calendar-popup {\n  width: 100% !important;\n  inset: 58% auto auto 88.5%;\n}\n\n.custom-calendar.ant-picker-outlined {\n  border: none !important;\n  justify-content: end;\n  padding: 0;\n  margin: 0;\n}\n\n.custom-calendar.ant-picker .ant-picker-suffix {\n  display: flex;\n  flex: none;\n  align-self: center;\n  margin-inline-start: 4px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 1;\n  pointer-events: none;\n  transition:\n    opacity 0.2s,\n    color 0.2s;\n  display: none;\n}\n\n.custom-calendar-popup .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.custom-calendar-popup .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: #d2042d !important;\n  color: white !important;\n  border: #d2042d !important;\n}\n\n.custom-calendar-popup .ant-picker-cell-today .ant-picker-cell-inner::before {\n  border: none !important;\n}\n\n.custom-calendar-popup .ant-picker-cell-today .ant-picker-cell-inner {\n  border: 1px solid #d2042d !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-dropdown\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  border: none !important;\n}\n\n.calendar-selected-dates-container {\n  margin-top: 2rem;\n  margin-inline-start: -0.7rem;\n}\n\n.selected-days-heading {\n  font-family: Roboto;\n  color: var(--Colors-Text-300, #5b5e5d);\n  margin-top: 100px;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-left: 1rem;\n}\n\n.datepicker-container .ant-picker .ant-picker-clear > * {\n  vertical-align: top;\n  display: none;\n}\n\n.total-selected-days {\n  font-family: Roboto;\n  color: #000;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-left: 1rem;\n}\n\n.select-campaign-dropdown {\n  font-family: Roboto;\n  display: flex;\n  height: 50px;\n  padding: 10px 20px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);\n  background: #fcfcfc;\n}\n\n.select-campaign-div .ant-select .ant-select-arrow {\n  color: #000;\n  width: 14px;\n  height: 7px;\n  flex-shrink: 0;\n  stroke-width: 2px;\n\n  stroke: var(--Colors-Text-300, #5b5e5d);\n}\n.select-campaign-div {\n  padding-top: 10px;\n}\n.select-campaign-label {\n  font-weight: 500;\n}\n\n.custom-new-campaign-drawer .ant-drawer-content-wrapper {\n  width: 20% !important;\n  box-shadow: none !important;\n}\n\n.ant-drawer-top.custom-new-campaign-drawer > .ant-drawer-content-wrapper {\n  box-shadow: none !important;\n}\n\n:where(.css-dev-only-do-not-override-cdzvx5).ant-drawer .ant-drawer-mask {\n  position: absolute;\n  inset: 0;\n  z-index: 1000;\n  background: none !important;\n  pointer-events: auto;\n}\n\n.dropdown-achor-tag {\n  color: #6a6a6a;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.select-campain-hover.a:hover {\n  background-color: transparent !important;\n}\n\n.custom-new-campaign-popover {\n  margin-left: 75%;\n  width: 17% !important;\n  position: fixed !important;\n}\n\n.user-campaign-list {\n  height: 19rem !important;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  cursor: pointer;\n}\n\n.user-campaign-list::-webkit-scrollbar {\n  display: flex;\n}\n\n.dropdown-main-menu\n  .ant-menu-item\n  .ant-menu-item-selected\n  .ant-menu-item-only-child\n  .dropdown-main-menu-items {\n  font-family: Roboto;\n  background-color: none !important;\n}\n\n.dropdown-main-menu .dropdown-main-menu-create-campaign-btn {\n  position: sticky;\n  z-index: 1;\n}\n\n.dropdown-main-menu\n  :where(.css-dev-only-do-not-override-cdzvx5).ant-menu-light\n  .ant-menu-item-selected {\n  background-color: white;\n}\n\n.dropdown-main-menu .ant-menu-light.ant-menu-root.ant-menu-vertical {\n  border-inline-end: none;\n}\n\n.user-campaign-list .ant-menu-item:hover {\n  background-color: #d2042d !important;\n  color: white !important;\n}\n\n.create-campaign-btn {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n\n.dropdown-main-menu-items .ant-menu-title-content {\n  font-family: Roboto;\n}\n\n.dropdown-main-menu-items.ant-dropdown-menu-vertical {\n  font-family: Roboto;\n  overflow-y: none;\n}\n\n.user-campaign-list .ant-menu-item {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n}\n\n.dropdown-main-menu-btn {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  border: none !important;\n  background: transparent !important;\n}\n\n.dropdown-main-menu-btn:hover,\n.dropdown-main-menu-btn:focus,\n.dropdown-main-menu-btn:active {\n  color: inherit !important;\n  background: transparent !important;\n  border: none !important;\n  outline: none !important;\n}\n\n.dropdown-main-menu-btn .ant-menu .ant-menu-item-selected {\n  background-color: none !important;\n  color: none !important;\n}\n\n.dropdown-main-menu-btn\n  .ant-menu-light:not(.ant-menu-horizontal)\n  .ant-menu-item:not(.ant-menu-item-selected):hover {\n  background-color: unset !important;\n}\n\n.ant-popover-arrow {\n  display: none !important;\n}\n\n.create-new-campaign-btn-parent .ant-btn:hover {\n  background-color: transparent !important;\n  background: none !important;\n}\n\n.addto-campaign-name-modal {\n  border-radius: 10px;\n  background: #fff;\n  padding: 5px 0px 0px 11px;\n}\n\n.addto-campaign-name-text {\n  margin-top: 3% !important;\n}\n\n.addto-campaign-name-text {\n  display: flex;\n  width: 295px;\n  height: 50px;\n  padding: 10px 20px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);\n  background: #fcfcfc;\n  border-left: 1px;\n}\n\n.addto-campaign-save-btn {\n  font-family: Roboto;\n  display: flex;\n  width: 100%;\n  height: 43px;\n  padding: 12px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  margin-top: 5%;\n  color: white !important;\n  text-decoration: none !important;\n}\n\n.addto-campaign-save-btn:hover,\n.addto-campaign-save-btn:focus,\n.addto-campaign-save-btn:active {\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  color: white !important;\n  border: none !important;\n  box-shadow: none !important;\n  text-decoration: none !important;\n}\n.go-back-parent {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n.addto-campaign-goback-btn {\n  font-family: Roboto;\n  display: flex;\n  height: 43px;\n  padding: 12px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  margin-top: -1rem;\n}\n.go-back-parent .ant-btn-color-link.ant-btn-variant-link {\n  color: #d2042d !important;\n  box-shadow: none;\n}\n\n.addto-campaign-goback-btn:hover,\n.addto-campaign-goback-btn:active,\n.addto-campaign-goback-btn:focus {\n  color: #d2042d !important;\n}\n\n.create-new-campaign-popover.ant-popover-content {\n  width: 20% !important;\n}\n\n.billBoard-popUp-calendar .ant-picker-panels > *:nth-child(2) {\n  display: none;\n}\n\n.billBoard-popUp-calendar\n  .ant-picker-panel:first-child\n  .ant-picker-header-next-btn,\n.billBoard-popUp-calendar\n  .ant-picker-panel:first-child\n  .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n\n.billBoard-popUp-calendar\n  .ant-picker-panel:last-child\n  .ant-picker-header-next-btn,\n.billBoard-popUp-calendar\n  .ant-picker-panel:last-child\n  .ant-picker-header-super-next-btn {\n  visibility: hidden !important;\n}\n\n.custom-calendar-popup .ant-picker-panel-container {\n  display: flex;\n}\n\n.custom-calendar-popup\n  .ant-picker-panel:first-child\n  .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:first-child\n  .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n\n.custom-calendar-popup .ant-picker-panels > div:nth-child(2) {\n  display: none !important;\n}\n\n.custom-calendar-popup .ant-picker-panel:last-child .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:last-child\n  .ant-picker-header-super-next-btn {\n  visibility: hidden !important;\n}\n.custom-cell.start-date,\n.custom-cell.end-date {\n  background-color: #d2042d;\n  color: white;\n}\n\n.custom-calendar input {\n  display: none !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(\n    .ant-picker-cell-disabled\n  ):before,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(\n    .ant-picker-cell-disabled\n  ):before,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  ):before {\n  background-color: transparent !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-in-range\n  .ant-picker-cell-inner,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-start\n  .ant-picker-cell-inner,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-end\n  .ant-picker-cell-inner {\n  color: white !important;\n}\n.login-to-access-campaign-popover-lgn-btn:hover {\n  color: white !important;\n  background-color: #d2042d !important;\n  border-color: #d2042d !important;\n}\n.create-new-campaign-popover.ant-modal .ant-modal-body {\n  margin-top: 10%;\n}\n.login-to-access-campaign-popover .ant-modal-content {\n  padding: 60px 16px !important;\n}\n\n.custom-calendar-popup .ant-picker-panel-container {\n  display: flex;\n}\n\n.custom-calendar-popup\n  .ant-picker-panel:first-child\n  .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:first-child\n  .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n\n.custom-calendar-popup .ant-picker-panels > div:nth-child(2) {\n  display: none !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-panel:first-child\n  .ant-picker-header-next-btn,\n.custom-calendar-popup\n  .ant-picker-panel:first-child\n  .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n\n.custom-calendar-arrows\n  .ant-picker-panel:last-child\n  .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:last-child\n  .ant-picker-header-super-next-btn {\n  visibility: hidden !important;\n}\n\n.custom-cell.start-date,\n.custom-cell.end-date {\n  background-color: #d2042d;\n  color: white;\n}\n\n.custom-calendar input {\n  display: none !important;\n}\n\n.custom-cell {\n  width: 65%;\n  height: 100%;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-in-range:not(\n    .ant-picker-cell-disabled\n  ):before,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(\n    .ant-picker-cell-disabled\n  ):before,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(\n    .ant-picker-cell-disabled\n  ):before {\n  border-radius: 0.4rem;\n  background-color: #e7002e2d !important;\n}\n\n.custom-calendar-popup tr {\n  display: flex;\n  justify-content: space-between !important;\n  gap: 0.5rem !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-in-range\n  .ant-picker-cell-inner,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-start\n  .ant-picker-cell-inner,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-end\n  .ant-picker-cell-inner {\n  color: white !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-start\n  .ant-picker-cell-inner {\n  background-color: #d2042d !important;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-end\n  .ant-picker-cell-inner {\n  background-color: #d2042d !important;\n}\n\n.custom-cell.disabled {\n  color: #ccc;\n  pointer-events: none;\n  background: #f5f5f5;\n}\n\n.custom-calendar-popup .ant-picker-panel-container {\n  display: flex;\n}\n\n.custom-calendar-popup\n  .ant-picker-panel:first-child\n  .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:first-child\n  .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n\n.custom-calendar-popup .ant-picker-panels > div:nth-child(2) {\n  display: none !important;\n}\n\n.custom-cell.in-range {\n  background-color: #d2042d;\n  color: white;\n}\n\n.custom-cell.start-date,\n.custom-cell.end-date {\n  background-color: #d2042d;\n  color: white;\n}\n\n.custom-calendar input {\n  display: none !important;\n}\n\n.custom-cell {\n  width: 100%;\n  height: 100%;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-in-range\n  .ant-picker-cell-inner,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-start\n  .ant-picker-cell-inner,\n.custom-calendar-popup\n  .ant-picker-cell-in-view.ant-picker-cell-range-end\n  .ant-picker-cell-inner {\n  color: white !important;\n}\n.login-to-access-campaign-popover-lgn-btn:hover {\n  color: white !important;\n  background-color: #d2042d !important;\n  border-color: #d2042d !important;\n}\n.create-new-campaign-popover.ant-modal .ant-modal-body {\n  margin-top: 10%;\n}\n.login-to-access-campaign-popover .ant-modal-content {\n  padding: 60px 16px !important;\n}\n.product-modal-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-model-menu-empty {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 20px;\n  font-weight: 200px;\n  font-style: normal;\n}\n.addto-campain-footer-sub-div {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n/* @media (max-width: 500) {\n  .custom-calendar-popup tr {\n    gap: 1.2rem !important;\n  }\n} */\n/* @media (max-width: 768) {\n  .custom-calendar-popup tr {\n    display: flex;\n    justify-content: space-between !important;\n    gap: -1.5rem !important;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
